
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Ensure navigation works properly
  const handleReturnHome = () => {
    console.log("Return home button clicked");
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-8 bg-white rounded-lg shadow-md">
        <h1 className="text-6xl font-bold mb-4 text-museum">404</h1>
        <p className="text-xl text-gray-600 mb-8">Oops! Page not found</p>
        <div className="flex flex-col gap-4 items-center">
          <Link 
            to="/" 
            onClick={(e) => {
              console.log("Return home link clicked");
              // No need for additional handling, Link component handles navigation
            }}
            className="inline-flex items-center gap-2 text-museum hover:text-museum-dark transition-colors underline"
          >
            <Home className="w-4 h-4" /> Return to Home
          </Link>
          
          <Button 
            onClick={handleReturnHome}
            className="bg-museum hover:bg-museum-dark"
          >
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
